import {
  SET_NOTIFICATIONS,
  SET_SELECTED_NOTIFICATION_ID,
  SET_NOTIFICATION_READ
} from './action-types'

export const setNotifications = (notifications) => ({
  type: SET_NOTIFICATIONS,
  payload: notifications
})

export const setSelectedNotificationId = (selectedNotificationId) => ({
  type: SET_SELECTED_NOTIFICATION_ID,
  payload: selectedNotificationId
})

export const setNotificationRead = (notificationId) => ({
  type: SET_NOTIFICATION_READ,
  payload: notificationId
})